export const fieldTypes = {
  value: "value",
  text: "text",
  number: "number",
  textarea: "textarea",
  date: "date",
  dropdown: "dropdown",
  radio: "radio",
  file: "file",
  check: "check",
  input: "input",
  spacer: "spacer",
  divider: "divider",
  badge: "badge",
  icon: "icon",
  html: "html",
  table: "table",
  list: "list",
  button: "button",
  iconButton: "iconButton",
  buttonGroup: "buttonGroup",
  condition: "condition",
  block: "block",
  groupBlock: "groupBlock",
  grid: "grid",
  container: "container",
  details: "details",
  accordion: "accordion",
  callout: "callout",
  dateWidget: "dateWidget",
  phoneWidget: "phoneWidget",
  addressWidget: "addressWidget",
  familyMembersWidget: "familyMembersWidget",
  firstNationStatusWidget: "firstNationStatusWidget",
  mapLocationWidget: "mapLocationWidget",
  mapViewerWidget: "mapViewerWidget",
  bankDetailsWidget: "bankDetailsWidget"
};

export const fieldSubTypes = {

  email: "email",
  phone: "phone",
  password: "password"
};

export const validFieldSubTypesByType = {
  [fieldTypes.input]: [
    "text",
    "email",
    "phone",
    "password",
    "textarea",
    "date",
    "datetime",
  ],
  [fieldTypes.file]: ["document", "image", "document_image"],
};

export const isEditableField = (type) => {
  if (type === fieldTypes.divider || type === fieldTypes.html || type === fieldTypes.table || type === fieldTypes.spacer 
    || type === fieldTypes.badge || type === fieldTypes.icon || type === fieldTypes.value || type === fieldTypes.list
    || type === fieldTypes.button || type === fieldTypes.iconButton  || isContainer(type) ) {
    return false;
  }

  return true;
};

export const isContainer = (type) => {
  if (type === fieldTypes.block || type === fieldTypes.grid || type === fieldTypes.container 
    || type === fieldTypes.details || type === fieldTypes.condition || type === fieldTypes.callout
    || type === fieldTypes.buttonGroup || type === fieldTypes.accordion) {
    return true;
  }

  return false;
}

export const isWidget = (type) => {
  if (type === fieldTypes.dateWidget || type === fieldTypes.phoneWidget || type === fieldTypes.addressWidget 
    || type === fieldTypes.familyMembersWidget || type === fieldTypes.firstNationStatusWidget || type === fieldTypes.mapViewerWidget 
    || type === fieldTypes.mapLocationWidget || type === fieldTypes.bankDetailsWidget) {
    return true;
  }

  return false;
}

export const getDefaultValue = (type) => {
  if ( type === fieldTypes.check) {
    return false;
  } if (type === fieldTypes.date) {
    return null;
  }

  return '';
}
